/**
 * Display metadata for MarketSignal dashboard categories.
 *
 * Keys mirror `MarketSignalDashboard.ACCESS_GRANT_KEYS` on the backend. A key
 * the frontend does not know yet falls back to the raw key so a new product
 * never breaks the landing page.
 */
export const CATEGORY_ORDER = ["market_signal", "device_signal", "referrals"];

export const CATEGORY_META = {
  market_signal: { label: "MarketSignal Volumes", pill: "Volumes" },
  device_signal: { label: "DeviceSignal", pill: "DeviceSignal" },
  referrals: { label: "Referral Analytics", pill: "Referral" },
};

export function categoryLabel(key) {
  return CATEGORY_META[key]?.label ?? key ?? "";
}

export function categoryPill(key) {
  return CATEGORY_META[key]?.pill ?? key ?? "";
}
